// Replay the displayed translation through a matching device voice, never a guessed language.
export function createDeskReader({ engine = window.speechSynthesis, Utterance = window.SpeechSynthesisUtterance, onEnd = () => {}, onError = () => {} } = {}) {
  let generation = 0, owned = false, current = null;
  const stop = () => { generation += 1; if (owned) { try { engine?.cancel(); } catch {} } owned = false; current = null; };
  const read = (text, language) => {
    stop();
    if (!engine || typeof Utterance !== "function") { onError("Read aloud is not available in this browser. Use Safari or Chrome with a device voice installed."); return false; }
    try {
      const code = language?.toLowerCase().split("-")[0];
      const voices = engine.getVoices();
      if (!voices.length) { onError("Device voices are not ready. Wait a moment and try Read translation again."); return false; }
      const matches = voices.filter(voice => voice.lang.toLowerCase().replace(/_/g,"-").split("-")[0] === code);
      const voice = matches.find(v => v.localService) || matches[0];
      if (!voice) { onError("No device voice is available for the selected language. Enable that language’s voice in the device settings, then try again."); return false; }
      let remaining = text.trim(); const chunks = [];
      while (remaining.length) {
        let end = Math.min(240, remaining.length);
        if (end < remaining.length) { const space = remaining.lastIndexOf(" ", end); if (space > 80) end = space + 1; }
        chunks.push(remaining.slice(0,end)); remaining = remaining.slice(end);
      }
      if (!chunks.length) return false;
      const id = generation; owned = true;
      const next = () => {
        if (!owned || generation !== id) return;
        const chunk = chunks.shift();
        if (chunk === undefined) { owned = false; current = null; onEnd(); return; }
        current = new Utterance(chunk); current.voice = voice; current.lang = voice.lang; current.rate = 1;
        current.onend = next;
        current.onerror = () => { if (generation === id && owned) { stop(); onError("The device could not read this translation. Check the volume and voice settings, then try again."); } };
        try { engine.speak(current); } catch { stop(); onError("The device could not start speech playback. Please try again."); }
      };
      next(); return owned;
    } catch { stop(); onError("Device speech is unavailable. Check the device voice settings and try again."); return false; }
  };
  // Prime asynchronous voice discovery; subsequent read calls always fetch the current list.
  try { engine?.getVoices(); } catch {}
  return { read, stop };
}
